export default "__VITE_ASSET__65611d02__"